<template>
  <v-layout
    class="address-list"
    row
    align-center
    :style="addressStyle"
    @click="setAddress"
  >
    <v-flex xs12>
      <v-icon
        class="middle"
        small
        color="#515152"
      >{{ addressIcon }}</v-icon>
      <span class="address-title">{{ !userAddress.title ? 'Saved address' : userAddress.title }}</span>
      <span class="address-text">{{ userAddress.road_name + ', ' + userAddress.postal_code }}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'address-card-component',
  props: {
    userAddress: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('delivery', [
      'address', 'isDeliverable'
    ]),
    addressStyle () {
      let styles = {
        padding: '8px',
        cursor: 'pointer'
      }
      if (this.address.id && parseInt(this.userAddress.id) === parseInt(this.address.id)) {
        styles.backgroundColor = 'rgba(9, 167, 149, 0.1)'
      }
      return styles
    },
    addressIcon () {
      return !this.userAddress.title ? 'fas fa-map-marker-alt' : (this.userAddress.title === 'Home' ? 'fas fa-home' : 'fas fa-building')
    }
  },
  methods: {
    async setAddress () {
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('delivery/fetchDeliveryInfo', this.userAddress.postal_code)
      this.$bus.$emit('showFullLoading', false)
      this.$emit('select-address')
    }
  }
}
</script>

<style scoped>
.middle {
  color: #515152;
  padding: 4px;
}
.address-title {
  font-size: 14px;
}
.address-text {
  font-size: 12px;
  color: #515152;
}
.address-list:hover {
  background: rgba(9, 167, 149, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/AddressCard.vue